/** Referrals (#554): remember a friend's code from ?ref= on any public page, so sign-up can send it. */
const KEY = 'cg.ref';

export function rememberReferral() {
  try {
    const q = new URLSearchParams(window.location.search);
    // A partner's link (#598) or a friend's (#554).
    const ref = q.get('partner') ?? q.get('ref');
    if (ref && /^[A-Za-z0-9]{4,16}$/.test(ref)) localStorage.setItem(KEY, ref);
  } catch {
    /* private mode: no referral, nothing else breaks */
  }
}

export function referralCode(): string {
  try {
    return localStorage.getItem(KEY) ?? '';
  } catch {
    return '';
  }
}

/** The code typed at sign-up (#598). */
export function setReferral(code: string) {
  try {
    if (code.trim()) localStorage.setItem(KEY, code.trim());
    else localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

export function forgetReferral() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
